import { render } from "./formPreview.vue?vue&type=template&id=de29f060&scoped=true"
import script from "./formPreview.vue?vue&type=script&lang=js"
export * from "./formPreview.vue?vue&type=script&lang=js"

import "./formPreview.vue?vue&type=style&index=0&id=de29f060&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de29f060"]])

export default __exports__